import CoreModel from 'core/models/core';


export default CoreModel.extend({
  urlRoot: MOOD_LOG_API_URL,

  mood_word: function () {
    var words = [
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten'
    ];
    return words[this.get('mood') - 1];
  },

  get_type: function () {
    var mood = this.get('mood');
    if (mood < 4) {
      return 'L';
    } else if (mood < 7) {
      return 'M';
    }
    return 'H';

  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/django-mood/mood/static/js/mood/models/mood_log.js
// module id = 68
// module chunks = 0